<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint || !!postId" @selectField="initTotalB" :use-tab-codes="['public-transportation']" field-name="공중교통수단명"/>

    <!-- 산업안전보건관리비 -->
    <div>
      <vs-row class="my-4">
        <vs-col><h5><i class="dot"></i>시설물 유지 예산 정보</h5></vs-col>
      </vs-row>
      <vs-row class="mb-8" style="border:1px solid #cdcdcd;">
        <vs-col>
          <ul class="table table-5" style="border-bottom:none;">
            <li class="header header-bg grid-row">
              <span>항목별</span>
              <span>예산</span>
              <span>당월 사용금액</span>
              <span>누계</span>
              <span>집행률</span>
            </li>

            <!-- 안전보건인건비 -->
            <li class="grid-row" v-for="item in form.inputB" :key="item.label">
              <span class="header-bg">{{ item.label }}</span>
              <span>
                <span class="isPrint" v-if="isPrint">{{ item.value1 }}</span>
                <ml-input v-else class="w-full" v-model=" item.value1" :readonly="board.readonly || !EnableSave" @keyup="calculateB"/>
              </span>
              <span>
                <span class="isPrint" v-if="isPrint">{{ item.value2 }}</span>
                <ml-input v-else class="w-full" v-model="item.value2" :readonly="board.readonly || !EnableSave" @keyup="calculateB"/>
              </span>
              <span>
                <span class="isPrint" v-if="isPrint">{{ item.value3 }}</span>
                <ml-input v-else class="w-full" v-model="item.value3" :readonly="true"/>
              </span>
              <span>
                <span class="isPrint" v-if="isPrint">{{ item.value4 }}</span>
                <ml-input v-else class="w-full" v-model="item.value4" :readonly="true"/>
              </span>
            </li>

            <!-- 누계 -->
            <li class="grid-row">
              <span class="header-bg">누계</span>
              <span>
                <span class="isPrint" v-if="isPrint">{{ totalInputB.value1 }}</span>
                <ml-input v-else class="w-full" v-model="totalInputB.value1" :readonly="true"/>
              </span>
              <span>
                <span class="isPrint" v-if="isPrint">{{ totalInputB.value2 }}</span>
                <ml-input v-else class="w-full" v-model="totalInputB.value2" :readonly="true"/>
              </span>
              <span>
                <span class="isPrint" v-if="isPrint">{{ totalInputB.value3 }}</span>
                <ml-input v-else class="w-full" v-model="totalInputB.value3" :readonly="true"/>
              </span>
              <span>
                <span class="isPrint" v-if="isPrint">{{ totalInputB.value4 }}</span>
                <ml-input v-else class="w-full" v-model="totalInputB.value4" :readonly="true"/>
              </span>
            </li>
          </ul>
        </vs-col>
      </vs-row>
    </div>

    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint"
                        :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'

export default {
  components: {
    FieldSelectModule,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FileUploadModule
  },
  props: {
    tab: Object,
    isPrint: Boolean,
    board: Object,
    value: Object,
    header: Object,
  },
  computed: {
    myInfo () {
      return this.$store.state.auth.userInfo
    },
    totalInputB () {
      return this.computeInputTotal(this.form.inputB)
    },
    postList() {
      return [...JSON.parse(JSON.stringify(this.$store.state.board.list))];
    },
    postId() {
      return parseInt(this.$route.params.postId);
    }
  },
  watch: {
    header: {
      immediate: true,
      deep: true,
      handler (/*header*/) {
        this.initTotalB()
      }
    },
    value: {
      deep: true,
      async handler (value) {
        // form 과 같은 데이터 인지 체크
        if (JSON.stringify(value) !== JSON.stringify(this.form)) {
          const keys = Object.keys(this.form)
          for (const key of keys) {
            if (value[key]) {
              this.form[key] = value[key]
            }
          }

          this.calculateB()
        }
      }
    },

    form: {
      deep: true,
      handler (value) {

        value.summary = {
          안전보건예산_사업장명: [],
          안전보건예산_항목명: []
        }

        let totalBudget = 0
        for (const data of this.form.inputB) {
          totalBudget += Number(this.removeComma(`${data.value1}`))
          value.summary['안전보건예산_항목명'].push({
            [data.label]:Number(this.removeComma(`${data.value1}`))
          })
        }

        value.summary['안전보건예산_사업장명'].push({
          [this.form.stdInfo.field_name]: totalBudget
        })

        this.$emit('input', value)
      }
    },

    EnableSave:{
      immediate: true,
      handler () {
        this.$emit("EnableSave", this.EnableSave)
      }
    },
  },
  data () {
    return {
      EnableSave: true,
      oldHeader: {},
      oldForm: {},
      form: {
        total:{},
        stdInfo:{},
        fileList: [],
        // totalB: 직전 문서에서 불러온 누계금액
        totalB: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,],
        inputB: [
          {label: '차량 등 점검비', value1: 0, value2: 0, value3:0, value4: 0.0},
          {label: '차량 등 진단비', value1: 0, value2: 0, value3:0, value4: 0.0},
          {label: '차량 등 성능평가비', value1: 0, value2: 0, value3:0, value4: 0.0},
          {label: '차량 등 보수비', value1: 0, value2: 0, value3:0, value4: 0.0},
          {label: '차량 등 보강비', value1: 0, value2: 0, value3:0, value4: 0.0},
          {label: '차량 등 교체비', value1: 0, value2: 0, value3:0, value4: 0.0},
          {label: '교육비', value1: 0, value2: 0, value3:0, value4: 0.0},
          {label: '안내 조치비', value1: 0, value2: 0, value3:0, value4: 0.0},
          {label: '인건비', value1: 0, value2: 0, value3:0, value4: 0.0},
          {label: '보고서 작성비', value1: 0, value2: 0, value3:0, value4: 0.0},
          {label: '유지·관리비', value1: 0, value2: 0, value3:0, value4: 0.0},
          {label: '설비 설치비', value1: 0, value2: 0, value3:0, value4: 0.0},
          {label: '물품·보호구 및 장비 구입비', value1: 0, value2: 0, value3:0, value4: 0.0},
          {label: '기타 비용', value1: 0, value2: 0, value3:0, value4: 0.0},
        ],
      }
    }
  },
  mounted () {
    this.initTotalB()
  },
  methods: {
    async initTotalB () {
      const postId = this.$route.params.postId
      if (!postId) {
        await this.loadListBoard()
        this.calculateB()
      }
    },
    computeInputTotal (inputSet) {
      const inputTotal = {label: '누계', value1: 0, value2: 0, value3: 0, value4: 0}

      for (const inputB of inputSet) {
        inputTotal.value1 += Number(this.removeComma(inputB.value1) ? this.removeComma(inputB.value1) : 0)
        inputTotal.value2 += Number(this.removeComma(inputB.value2) ? this.removeComma(inputB.value2) : 0)
        inputTotal.value3 += Number(this.removeComma(inputB.value3) ? this.removeComma(inputB.value3) : 0)
      }

      // NaN 방지
      if (inputTotal.value1 > 0) {
        inputTotal.value4 = Math.floor(inputTotal.value3 * 10000.0 / inputTotal.value1) / 100
      } else {
        inputTotal.value4 = 0
      }

      inputTotal.value1 = this.comma(inputTotal.value1)
      inputTotal.value2 = this.comma(inputTotal.value2)
      inputTotal.value3 = this.comma(inputTotal.value3)

      this.form.total = inputTotal
      return inputTotal
    },
    async loadListBoard () {
      const projectId = this.$route.params.proj_id
      const boardId = 478
      const page = 1
      const perPage = 1000
      const dateTarget = 'content$header.full'
      const dateBegin = `${new Date().getFullYear()}-01-01`
      const dateEnd = `${new Date().getFullYear()}-12-31`
      const keyword = [`content$body.stdInfo.field_id*${this.form.stdInfo.field_id}`];

      await this.$store.dispatch('board/LOAD_POST_LIST', {
        boardId,
        projectId,
        page,
        perPage,
        keyword,
        dateTarget,
        dateBegin,
        dateEnd
      })
      const rows = [...JSON.parse(JSON.stringify(this.$store.state.board.list))]
      const totalB = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]

      if (rows.length > 0) {
        for (const data of rows) {
          const header = this.getHeader(data)
          const content = this.getContent(data)
          data.header = header;
          data.content = content;
          delete data.post_content;
        }

        // 검색된 데이터를, header.full 오름차순으로 정렬한다
        const sortedRows = rows.sort(function (a, b) {
          const x = new Date(a.header.full).getTime();
          const y = new Date(b.header.full).getTime();

          if (x < y)  return -1;
          if (x > y)  return 1;
          return 0;
        })

        // 작성된 글 중에서, 선택된 날짜와 가장 가까운 과거의 데이터를 추출한다
        let lastData;
        // 작성되 글 중에서, 선택된 날짜와 동일한 데이터를 추출한다
        let equalData;
        for (const data of sortedRows) {
          if (new Date(data.header.full).getTime() < new Date(this.header.full).getTime()) {
            lastData = data;
          }
          if (new Date(this.header.full).getTime() === new Date(data.header.full).getTime()) {
            equalData = data;
          }
        }

        // 작성된 글 중에서, 가장 마지막 글의 날짜를 확인한다
        const latestDate = sortedRows[sortedRows.length - 1].header.full;

        // 만약 현재 작성하는 날짜가, 이미 작성된 글보다 미래가 아닐 경우, 작성할 수 있으면 안된다
        if (new Date(this.header.full).getTime() <= new Date(latestDate).getTime()) {
          this.EnableSave = false;

          // 만약 해당 날짜에 작성된 데이터가 있다면, 해당 데이터를 화면에 표시한다
          if (equalData) {
            for (let i = 0; i < equalData.content.inputB.length; i++) {
              this.form.inputB[i].value1 = Number(this.removeComma(equalData.content.inputB[i].value1));
              this.form.inputB[i].value2 = Number(this.removeComma(equalData.content.inputB[i].value2));
              this.form.inputB[i].value3 = Number(this.removeComma(equalData.content.inputB[i].value3));
              this.form.inputB[i].value4 = Number(this.removeComma(equalData.content.inputB[i].value4));

              if (lastData) {
                totalB[i] = Number(this.removeComma(lastData.content.inputB[i].value3));
              } else {
                totalB[i] = 0;
              }
            }
          }

          // 만약 해당 날짜에 데이터가 없다면, 가장 최근 과거의 데이터를 화면에 표시한다 (당월 사용 금액은 데이터가 없으므로 0)
          else if (lastData) {
            for (let i = 0; i < lastData.content.inputB.length; i++) {
              this.form.inputB[i].value1 = Number(this.removeComma(lastData.content.inputB[i].value1));
              this.form.inputB[i].value2 = Number(this.removeComma(lastData.content.inputB[i].value2));
              this.form.inputB[i].value3 = Number(this.removeComma(lastData.content.inputB[i].value3));
              this.form.inputB[i].value4 = Number(this.removeComma(lastData.content.inputB[i].value4));
              totalB[i] = 0;
            }
          } else {
            for (let i = 0; i <  this.form.inputB.length; i++) {
              this.form.inputB[i].value1 = 0;
              this.form.inputB[i].value2 = 0;
              this.form.inputB[i].value3 = 0;
              this.form.inputB[i].value4 = 0;
              totalB[i] = 0;
            }
          }
        }

        // 만약 새로운 날짜에 대한 데이터를 입력할 경우, 가장 최근 과거의 데이터를 화면에 표시한다
        else {
          this.EnableSave = true;

          if (lastData) {
            for (let i = 0; i < lastData.content.inputB.length; i++) {
              const inputB = lastData.content.inputB[i]
              this.form.inputB[i].value1 = Number(this.removeComma(lastData.content.inputB[i].value1));
              this.form.inputB[i].value2 = 0;
              totalB[i] = Number(this.removeComma(inputB.value3))
            }
          }
        }
        this.form.totalB = totalB
      } else {
        this.EnableSave = true;
      }

      if (!this.form.stdInfo.field_id) {
        this.EnableSave = false;
      }
    },

    getContent (data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content)
        return content.body
      }
    },
    getHeader (data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content)
        return content.header
      }
    },
    calculateB () {
      this.calculateInputs('inputB', 'totalB')
    },
    calculateInputs (inputName, totalName) {
      const inputSet = this.form[inputName]
      const list = []
      for (let i = 0; i < inputSet.length; i++) {
        const inputB = inputSet[i]

        // 콤마 삭제
        const value = {
          label: inputB.label,
          value1: this.removeComma(inputB.value1),
          value2: this.removeComma(inputB.value2),
        }

        // 누계사용금액 계산
        value.value3 = Number(this.removeComma(`${this.form[totalName][i]}`)) + Number(`${value.value2}`)

        // 집행률 계산
        if (Number(this.removeComma(`${value.value1}`)) > 0) {
          value.value4 = Math.floor(Number(this.removeComma(`${value.value3}`)) * 10000.0 / Number(this.removeComma(`${value.value1}`))) / 100
        } else {
          value.value4 = 0
        }
        list.push(value)
      }

      // 콤마 추가
      for (const inputB of list) {
        inputB.value1 = this.comma(inputB.value1)
        inputB.value2 = this.comma(inputB.value2)
        inputB.value3 = this.comma(inputB.value3)
        inputB.value4 = inputB.value4 ? inputB.value4 : '0'
      }
      this.form[inputName] = JSON.parse(JSON.stringify(list))
    },
    comma (str) {
      return `${str}`.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },

    removeComma (str) {
      if (str) {
        const noneComma = `${str}`.replaceAll(',', '')
        return `${Number(noneComma)}`
      }
      return '0'
    }
  },
}
</script>

<style scoped>

</style>
